import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslocoService } from '@ngneat/transloco';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { upperFirst } from 'lodash';
import { takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject, combineLatest } from 'rxjs';

import { PageViewService } from './page-view.service';
import { Page } from '../admin/models/page.model';

@Component({
  selector: 'kt-page-view',
  templateUrl: './page-view.component.html',
  styleUrls: ['../max-width-page-view-components.scss'],
})
export class PageViewComponent implements OnInit, OnDestroy {
  page: string;
  page$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  title$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  content$: BehaviorSubject<SafeHtml> = new BehaviorSubject<SafeHtml>(null);

  private unsubscribe: Subject<any>;

  constructor(
    private route: ActivatedRoute,
    private transloco: TranslocoService,
    private sanitizer: DomSanitizer,
    private service: PageViewService,
  ) {
    this.unsubscribe = new Subject();
  }

  ngOnInit() {
    this.route.paramMap.pipe(takeUntil(this.unsubscribe)).subscribe((paramMap) => {
      this.service
        .getPageBySlug(paramMap.get('page'))
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((page: Page) => {
          const lang = upperFirst(this.transloco.getActiveLang());
          this.page$.next(page);
          this.title$.next(page[`title${lang}`]);
          this.content$.next(this.sanitizer.bypassSecurityTrustHtml(page[`content${lang}`]));
        });
    });

    combineLatest([this.transloco.langChanges$, this.page$])
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([lang, page]) => {
        if (lang && page) {
          this.title$.next(page[`title${upperFirst(lang)}`]);
          this.content$.next(this.sanitizer.bypassSecurityTrustHtml(page[`content${upperFirst(lang)}`]));
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
